import { useCallback, useMemo } from 'react'
import moment from 'moment-timezone'

import PlainCalendar from '../plain-calendar'
import { dateFormat as dateFormatDefault } from '../plain-calendar/date-format'
import PlainListMonths from '../plain-list-months'
import DateMonthSwitcher from './date-month-switcher'

import styles from './date-month-content.module.scss';


const daysViewConditionDefault = (d: string) => /^\d+(-|\.|\s)\d+(-|\.|\s)\d+$/.test(d)

type Props = {
  date?: string,
  dateFormat?: string,
  daysViewCondition?: (date: string) => boolean,
  monthsAmount?: number,
  panelClose: () => void,
  onChangeDate?: (date: string, format: string, daily: boolean) => void,
  hideDateMonthSwitcher?: boolean,
  monthsInFuture?: number,
}

const DateMonthContent = ({
  date,
  dateFormat = dateFormatDefault,
  daysViewCondition = daysViewConditionDefault,
  monthsAmount,
  panelClose,
  onChangeDate,
  hideDateMonthSwitcher,
  monthsInFuture,
}: Props) => {
  const isDaily = !date || daysViewCondition(date)

  const dateClick = useCallback((date_: string, format_: string) => {
    if (onChangeDate) {
      onChangeDate(date_, format_, /^.+(-|\.).+(-|\.).+/.test(date_))
    }
    panelClose()
  }, [onChangeDate, panelClose])

  const daysSelected = useMemo(() => {
    if (date) {
      const calendarDate = moment(date, dateFormat).format(dateFormatDefault)
      return {
        [calendarDate]: calendarDate,
      }
    }
    return {}
  }, [date, dateFormat])

  const daysContent = (
    <PlainCalendar
      onDayClick={dateClick}
      daysSelected={daysSelected}
      dateFormat={dateFormatDefault}
    />
  )

  const monthsContent = (
    <PlainListMonths
      onMonthClick={dateClick}
      amount={monthsAmount}
      activeDate={date}
      activeDateFormat={dateFormat}
      monthsInFuture={monthsInFuture}
    />
  )

  if (hideDateMonthSwitcher) {
    return (
      <div className={styles.root}>
        {isDaily ? daysContent : monthsContent}
      </div>
    )
  }

  const tabIndexByCurrentDate = isDaily ? 1 : 2

  return (
    <div className={styles.root}>
      <DateMonthSwitcher
        tabIndex={tabIndexByCurrentDate}
        daysContent={daysContent}
        monthsContent={monthsContent}
      />
    </div>
  )
}

export default DateMonthContent
